var map = {
	"./logo-alphabet.svg": 552,
	"./logo-amazon-2.svg": 553,
	"./logo-amazon.svg": 595,
	"./logo-azercell.svg": 596,
	"./logo-bank-of-america.svg": 597,
	"./logo-barclays.svg": 598,
	"./logo-bbc.svg": 599,
	"./logo-bloomberg.svg": 554,
	"./logo-bnp-paribas.svg": 600,
	"./logo-booking.svg": 601,
	"./logo-citibank.svg": 602,
	"./logo-cnbc.svg": 555,
	"./logo-cnbc2.svg": 603,
	"./logo-coca-cola-auto.svg": 551,
	"./logo-coca-cola-white.svg": 1680,
	"./logo-coca-cola.svg": 604,
	"./logo-deloitte.svg": 605,
	"./logo-experian.svg": 606,
	"./logo-facebook.svg": 607,
	"./logo-forbes.svg": 556,
	"./logo-g.svg": 1681,
	"./logo-goldman-sachs-new.svg": 608,
	"./logo-goldman-sachs.svg": 1549,
	"./logo-google-new.svg": 609,
	"./logo-google.svg": 610,
	"./logo-h.svg": 611,
	"./logo-henkel.svg": 612,
	"./logo-hsbc-new.svg": 613,
	"./logo-hsbc.svg": 1547,
	"./logo-ikea-new.svg": 614,
	"./logo-ikea.svg": 1682,
	"./logo-infineon.svg": 615,
	"./logo-instagram-icon.svg": 549,
	"./logo-instagram.svg": 616,
	"./logo-jp-morgan.svg": 617,
	"./logo-jti.svg": 618,
	"./logo-linkedin.svg": 619,
	"./logo-meta-new.svg": 548,
	"./logo-meta.svg": 1650,
	"./logo-morgan-stanley-new.svg": 620,
	"./logo-morgan-stanley.svg": 1548,
	"./logo-netflix.svg": 1545,
	"./logo-oracle.svg": 557,
	"./logo-paypal.svg": 621,
	"./logo-pwc-new.svg": 550,
	"./logo-pwc.svg": 1683,
	"./logo-spotify.svg": 1546,
	"./logo-tesla.svg": 622,
	"./logo-usa-today.svg": 558,
	"./logo-visa.svg": 623,
	"./logo-walmart.svg": 559,
	"./logo-wsj.svg": 560,
	"./logo-youtube.svg": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1048;